import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

const resources_old = {
  cz: {
    translation: {
      navigation: {
        home: "Domů",
        shop: "Všechny produkty",
        services: "Služby",
        contact: "Kontakt",
        news: "Novinky",
        admin: "Admin",
        about: "O nás",
        products: "Produkty",
        references: "Reference",
        laboratories: "Laboratoře",
        projects: "Projekty"
      },
      landing: {
        title: "Cybertronic",
        subtitle: "Budoucnost je zde",
        description: "Průkopníci v oblasti pokročilých technologií. Od intimních pomůcek přes průmyslovou robotiku až po futuristické výzkumné projekty.",
        sexMachines: "Ostatní",
        sexMachinesDesc: "Revoluční technologie v oblasti intimních pomůcek s AI řízením",
        robotics: "Cybertronic Robotics",
        roboticsDesc: "Vojenské a průmyslové robotické systémy na míru",
        unlimited: "Cybertronic Unlimited",
        unlimitedDesc: "Futuristické laboratoře a speciální výzkumné projekty",
        newBadge: "NOVINKA",
        selectSection: "Vyberte sekci pro pokračování"
      },
      sexMachines: {
        title: "Ostatní",
        subtitle: "Revoluční technologie intimních pomůcek",
        description: "Naše nejmodernější produkty kombinují umělou inteligenci, robotiku a luxusní design pro nezapomenutelné zážitky.",
        features: {
          ai: "AI řízení",
          aiDesc: "Pokročilé algoritmy pro personalizovaný zážitek",
          safety: "Bezpečnost",
          safetyDesc: "Nejvyšší standardy kvality a bezpečnosti",
          premium: "Prémiová kvalita",
          premiumDesc: "Luxusní materiály a precizní zpracování"
        },
        products: "Produkty",
        inquiry: "Nezávazná poptávka",
        inquiryDesc: "Máte zájem o naše produkty? Kontaktujte nás pro více informací."
      },
      robotics: {
        title: "Cybertronic Robotics",
        subtitle: "Pokročilé robotické systémy",
        description: "Specializujeme se na vývoj vojenských a průmyslových robotů, automatizaci a kognitivní inteligenci.",
        about: "O nás",
        aboutDesc: "Historie a zaměření na vývoj robotických systémů",
        products: "Produkty",
        productsDesc: "Vojenské roboty, průmyslové roboty, speciální systémy",
        services: "Služby",
        servicesDesc: "Vývoj na míru, údržba, servis, školení",
        references: "Reference",
        referencesDesc: "Dokončené projekty s fotkami a popisy"
      },
      unlimited: {
        title: "Cybertronic Unlimited",
        subtitle: "Futuristické laboratoře a výzkum",
        description: "Zkoumáme nejpokročilejší technologie budoucnosti a posouváme hranice vědy a techniky.",
        about: "O projektu",
        aboutDesc: "Popis zaměření Unlimited a unikátních technologií",
        laboratories: "Laboratoře",
        laboratoriesDesc: "Fotogalerie a popis jednotlivých laboratoří",
        projects: "Speciální projekty",
        projectsDesc: "Seznam projektů s možností rozkliknout detail",
        shop: "Všechny produkty",
        shopDesc: "Katalog produktů - prototypy, doplňky, merch",
        researchTitle: "Výzkum a vývoj",
        researchDesc: "Naše laboratoře se věnují výzkumu nejmodernějších technologií, od umělé inteligence po pokročilou robotiku a bioinženýrství.",
        prototypesTitle: "Prototypy",
        prototypesDesc: "Vyvíjíme a testujeme prototypy futuristických zařízení, která posouvají hranice toho, co je technologicky možné.",
        experimentalTitle: "Experimentální projekty",
        experimentalDesc: "Experimentujeme s technologiemi, které jsou na hraně současné vědy a připravujeme budoucnost technologického pokroku."
      },
      shop: {
        title: "E-shop",
        addToCart: "Přidat do košíku",
        addedToCart: "Produkt byl přidán do košíku",
        moreInfo: "Více o produktu",
        moreAboutProduct: "Více o produktu",
        cart: "Košík",
        checkout: "Objednat",
        price: "Cena",
        category: "Kategorie",
        inquiry: "Poptávka",
        inquiryForm: "Formulář poptávky",
        emptyCart: "Košík je prázdný",
        orderForm: "Objednávkový formulář",
        sendOrder: "Odeslat objednávku",
        sending: "Odesílám...",
        loadingProducts: "Načítání produktů...",
        popular: "POPULÁRNÍ",
        orderSent: "Objednávka odeslána!",
        orderCreatedSuccessfully: "Vaše objednávka byla úspěšně vytvořena",
        orderNumberLabel: "Číslo objednávky",
        paymentDetailsSent: "Platební údaje byly odeslány na váš email.",
        paymentDeadline: "Prosím proveďte platbu do",
        workingDays: "3 pracovních dnů",
        accountNumber: "Číslo účtu:",
        variableSymbol: "Variabilní symbol:",
        continuesShopping: "Pokračovat v nákupu",
        selectQuantity: "Vyberte množství",
        cancel: "Zrušit",
        add: "Přidat",
        soldOut: "Vyprodáno",
        description: "Popis",
        categories: "Kategorie",
        orderSummary: "Souhrn objednávky",
        shippingType: "Typ dopravy",
        subtotal: "Mezisoučet",
        shipping: "Doprava",
        total: "Celkem",
        order: "Objednat",
        fillDeliveryInfo: "Vyplňte dodací údaje",
        nameCompany: "Jméno / Firma",
        billingAddress: "Fakturační adresa",
        shippingAddress: "Dodací adresa (nechte prázdné pokud je stejná)",
        gateWidth: "Šířka vrat (cm)",
        gateHeight: "Výška vrat (cm)",
        workHours: "Pracovní doba pro závoz (např. Po-Pá 7-15)",
        notes: "Poznámka / individuální přání",
        agreeTerms: "Souhlasím se zpracováním osobních údajů a",
        termsConditions: "obchodními podmínkami",
        manual: "Manuál",
        downloadManual: "Stáhnout manuál",
        videoTutorial: "Video návod",
        playVideo: "Přehrát video"
      },
      cart: {
        goodEvening: "Dobrý večer,",
        goodDay: "Dobrý den,",
        privacyInfo: "Žádné informace o našich zákaznících neukládáme, po vytvoření objednávky se vytvoří objednávka a po expedici, se veškerá karta zákazníka maže. Historii nákupu lze pak dohledat jen skrze uložení faktur v zákonné lhůtě.",
        thankYou: "Děkuji",
        terms: "Obchodní podmínky"
      },
      contact: {
        title: "Kontakt",
        subtitle: "Upřednostňujeme emailovou komunikaci, která nám umožňuje přesně reagovat a předcházet nedorozuměním. Pokud potřebujete rychlé informace, zavolejte nám nebo si domluvte schůzku.",
        serviceNote: "Servisní požadavky zasílejte vždy na email!",
        name: "Jméno",
        email: "Email",
        phone: "Telefon",
        message: "Zpráva",
        send: "Odeslat",
        gdpr: "Souhlasím se zpracováním osobních údajů",
        required: "Povinné pole",
        contactInfo: "Kontaktní informace",
        workingHours: "Pracovní doba",
        workingHoursText: "Po–Pá: 8:00 – 16:00 (technická podpora do 18:00)\nSo–Ne: Zavřeno (technická podpora do 14:00)",
        billingAddress: "Fakturační adresa",
        billingAddressText: "CYBERTRONIC ROBOTICS S.R.O.\nAnenská 405/7\n69501 Hodonín\n(nepřijímáme zde poštu)",
        contactAddress: "Kontaktní adresa",
        contactAddressText: "CYBERTRONIC Unlimited\nIng. René Letocha\nSvatobořice 76\n69604 Svatobořice, okr. Hodonín",
        companyInfo: "Firemní údaje",
        companyInfoText: "IČO: 01526138 | DIČ: CZ01526138\nÚčet: 2700408786/2010 (Fio Banka)\nIBAN: CZ2220100000002700408786\nSWIFT/BIC: FIOBCZPPXXX\nRegistrace: C 79792 vedená u Krajského soudu v Brně",
        map: "Mapa",
        contactUs: "Kontaktujte nás",
        phoneNote: "Ing. René Letocha – jednatel, vývoj",
        namePlaceholder: "Vaše jméno",
        emailPlaceholder: "vas@email.cz",
        phonePlaceholder: "+420 777 875 098",
        messagePlaceholder: "Vaše zpráva...",
        sending: "Odesílání...",
        successMessage: "Zpráva byla úspěšně odeslána! Brzy se vám ozveme.",
        errorMessage: "Chyba při odesílání zprávy. Zkuste to prosím znovu nebo nás kontaktujte přímo na email."
      },
      news: {
        subtitle: "Nejnovější zprávy ze světa Cybertronic"
      },
      admin: {
        title: "Administrace",
        login: "Přihlášení",
        password: "Heslo",
        submit: "Odeslat",
        products: "Produkty",
        news: "Novinky",
        addProduct: "Přidat produkt",
        editProduct: "Upravit produkt",
        adminPanel: "Admin panel",
        goToMainPage: "Přejděte na hlavní stránku a přihlaste se jako admin pro správu produktů"
      },
      common: {
        noProductsInSection: "Žádné produkty v této sekci",
        productsWillBeAdded: "Produkty budou brzy přidány do jednotlivých sekcí",
        noProductsAvailable: "Zatím nejsou k dispozici žádné produkty",
        completeOverview: "Kompletní přehled všech našich produktů ze všech sekcí",
        addProduct: "Přidat produkt",
        addNewProduct: "Přidat nový produkt",
        manageCategories: "Spravovat kategorie",
        manageNews: "Spravovat novinky",
        editProduct: "Upravit produkt",
        deleteProduct: "Smazat produkt",
        saveChanges: "Uložit změny",
        cancel: "Zrušit",
        add: "Přidat",
        all: "Všechny",
        categoryManagement: "Správa kategorií",
        newsManagement: "Správa novinek",
        addCategory: "Přidat kategorii",
        addNews: "Přidat novinku",
        categoryName: "Název kategorie",
        titleCs: "Název (CS)",
        titleEn: "Název (EN)",
        shortDescriptionCs: "Krátký popis (CS)",
        areYouSure: "Jste si jisti, že chcete smazat tento produkt?",
        yes: "ANO",
        no: "NE",
        loadingProducts: "Načítání produktů...",
        popular: "POPULÁRNÍ"
      },
      services: {
        title: "Služby",
        subtitle: "Profesionální služby a řešení na míru. Kromě vývoje a výroby elektroniky nabízíme také specializované služby v oblasti obrábění materiálů a technické podpory.",
        contactForServices: "Kontakt pro služby",
        polystyrene: {
          title: "Řezání polystyrénu",
          description: "Nabízíme zakázkové řezání polystyrénu dle návrhu zákazníka. Prioritou je pro nás však vývoj a výroba elektroniky, proto můžeme zakázku z nedostatku času odmítnout.",
          specs: "Vlastní počítačem řízená řezačka polystyrénu Alfa Cutter T2100 s pracovní plochou 1300x1000x600mm.",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Specifikace:",
          materialsLabel: "Materiály:"
        },
        laser: {
          title: "Řezání a gravírování laserem",
          description: "Nabízíme zakázkové řezání a gravírování laserem dle návrhu zákazníka.",
          specs: "CO2 laser o výkonu 60W s efektivní pracovní plochou 500x400mm",
          materials: "Sklo, plast, dřevo, akrylátové sklo, plexisklo",
          priceLabel: "Cena:",
          specsLabel: "Specifikace:",
          materialsLabel: "Materiály:"
        },
        plasma: {
          title: "Řezání kovů plazmou do 20mm",
          description: "Nabízíme zakázkové řezání elektricky vodivých materiálů na CNC routeru s plazmou Pegas 101.",
          specs: "Efektivní pracovní plocha CNC plazmy je 1500x3000mm",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Specifikace:",
          materialsLabel: "Materiály:"
        },
        embroidery: {
          title: "Vyšívání na textil automatem",
          description: "Nabízíme zakázkové vyšívání návrhu vektorové grafiky z Corelu na textilní materiály.",
          specs: "",
          materials: "Bundy, trička, ručníky s kombinací až 6 barev v jednom motivu",
          priceLabel: "Cena:",
          specsLabel: "Specifikace:",
          materialsLabel: "Materiály:"
        },
        printing3d: {
          title: "3D tisk z ABS plastu",
          description: "Nabízíme zakázkový 3D tisk předmětů na 3D tiskárnách s pracovní plochou 200*200*200mm a 600*400*400mm.",
          specs: "",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Specifikace:",
          materialsLabel: "Materiály:"
        },
        welding: {
          title: "Svařování hliníku, nerezu a černého plechu - TIG, MIG",
          description: "Nabízíme zakázkové svařování hliníku, nerezu i černého plechu výkonnými automatickými svářečkami.",
          specs: "",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Specifikace:",
          materialsLabel: "Materiály:"
        },
        milling3d: {
          title: "3D frézování včetně 3D skenování",
          description: "Nabízíme zakázkové frézování 2D i 3D s možností 3D skenování předmětů s přesností 1mm.",
          specs: "Pracovní plocha 1500x2500x250mm, frézujeme měkké materiály (plasty, dřevo, hliník, mosaz, plexi)",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Specifikace:",
          materialsLabel: "Materiály:"
        },
        training: {
          title: "Školení v oblasti elektroniky, CAD a CAM systémů",
          description: "Nabízíme odborné školení na CAD a CAM systémy, elektronické systémy, rušení, EMC.",
          specs: "",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Specifikace:",
          materialsLabel: "Materiály:"
        },
        service: {
          title: "Servisní výjezd",
          description: "Servis strojů je nutné hlásit předem nejlépe emailem s drobným popisem závady.",
          specs: "",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Specifikace:",
          materialsLabel: "Materiály:"
        },
        transport: {
          title: "Autodoprava",
          description: "Nabízíme drobnou autodopravu na valníku Peugeot Boxer 3,0 do 3,5 tuny.",
          specs: "Velikost přepravní plochy 2100x4100mm s maximální hmotností 750Kg",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Specifikace:",
          materialsLabel: "Materiály:"
        }
      },
      footer: {
        rights: "Všechna práva vyhrazena",
        contact: "Kontakt",
        email: "Email",
        phone: "Telefon",
        description: "Budoucnost technologie je zde. Specializujeme se na pokročilé robotické systémy a inovativní řešení.",
        websiteBy: "Tvorba webu:"
      },
      profile: {
        title: "Profil",
        founder: "Zakladatel & CEO",
        bio: "Více než 15 let se věnuji tvorbě elektroniky, robotiky a automatizace. Specializuji se na zakázkový vývoj a inovativní technologická řešení.",
        socialMedia: "Sociální sítě",
        contact: "Kontakt",
        admin: "Admin",
        adminLogin: "Přihlášení administrátora",
        username: "Uživatelské jméno",
        login: "Přihlásit",
        logout: "Odhlásit",
        back: "Zpět",
        changePhoto: "Změnit profilovou fotku",
        imageUrl: "URL obrázku",
        uploadFile: "Nahrát soubor",
        dragImage: "Přetáhněte obrázek sem",
        preview: "Náhled",
        save: "Uložit"
      },
      cookies: {
        title: "Cookies a soukromí",
        description: "Používáme cookies pro zlepšení vašeho zážitku, analýzu návštěvnosti a marketingové účely. Vaše data jsou zpracovávána bezpečně a anonymně.",
        essential: "Nezbytné cookies",
        essentialDesc: "Vyžadovány pro základní funkčnost webu. Vždy aktivní.",
        analytics: "Analytické cookies",
        analyticsDesc: "Pomáhají nám pochopit, jak návštěvníci interagují s našimi webovými stránkami (Google Analytics).",
        accept: "Přijmout všechny cookies",
        decline: "Odmítnout",
        showDetails: "Podrobnosti",
        hideDetails: "Skrýt podrobnosti",
        footer: "Přijetím vyjadřujete souhlas s používáním cookies podle našich Zásad ochrany osobních údajů."
      },
      tutorials: {
        title: "Video návody",
        subtitle: "Naučte se používat naše produkty pomocí podrobných video návodů",
        noTutorials: "V této kategorii zatím nejsou dostupné žádné návody.",
        watchVideo: "Přehrát návod"
      }
    }
  },
  sk: {
    translation: {
      navigation: {
        home: "Domov",
        shop: "Všetky produkty",
        services: "Služby",
        contact: "Kontakt",
        news: "Novinky",
        admin: "Admin",
        about: "O nás",
        products: "Produkty",
        references: "Referencie",
        laboratories: "Laboratóriá",
        projects: "Projekty"
      },
      landing: {
        title: "Cybertronic",
        subtitle: "Budúcnosť je tu",
        description: "Priekopníci v oblasti pokročilých technológií. Od intímnych pomôcok cez priemyselnú robotiku až po futuristické výskumné projekty.",
        sexMachines: "Ostatné",
        sexMachinesDesc: "Revolučná technológia v oblasti intímnych pomôcok s AI riadením",
        robotics: "Cybertronic Robotics",
        roboticsDesc: "Vojenské a priemyselné robotické systémy na mieru",
        unlimited: "Cybertronic Unlimited",
        unlimitedDesc: "Futuristické laboratóriá a špeciálne výskumné projekty",
        newBadge: "NOVINKA",
        selectSection: "Vyberte sekciu pre pokračovanie"
      },
      sexMachines: {
        title: "Ostatné",
        subtitle: "Revolučná technológia intímnych pomôcok",
        description: "Naše najmodernejšie produkty kombinujú umelú inteligenciu, robotiku a luxusný dizajn pre nezabudnuteľné zážitky.",
        features: {
          ai: "AI riadenie",
          aiDesc: "Pokročilé algoritmy pre personalizovaný zážitok",
          safety: "Bezpečnosť",
          safetyDesc: "Najvyššie štandardy kvality a bezpečnosti",
          premium: "Prémiová kvalita",
          premiumDesc: "Luxusné materiály a precízne spracovanie"
        },
        products: "Produkty",
        inquiry: "Nezáväzná dopyt",
        inquiryDesc: "Máte záujem o naše produkty? Kontaktujte nás pre viac informácií."
      },
      robotics: {
        title: "Cybertronic Robotics",
        subtitle: "Pokročilé robotické systémy",
        description: "Špecializujeme sa na vývoj vojenských a priemyselných robotov, automatizáciu a kognitívnu inteligenciu.",
        about: "O nás",
        aboutDesc: "História a zameranie na vývoj robotických systémov",
        products: "Produkty",
        productsDesc: "Vojenské roboty, priemyselné roboty, špeciálne systémy",
        services: "Služby",
        servicesDesc: "Vývoj na mieru, údržba, servis, školenie",
        references: "Referencie",
        referencesDesc: "Dokončené projekty s fotkami a popismi"
      },
      unlimited: {
        title: "Cybertronic Unlimited",
        subtitle: "Futuristické laboratóriá a výskum",
        description: "Skúmame najmodernejšie technológie budúcnosti a posúvame hranice vedy a techniky.",
        about: "O projekte",
        aboutDesc: "Popis zamerania Unlimited a unikátnych technológií",
        laboratories: "Laboratóriá",
        laboratoriesDesc: "Fotogaléria a popis jednotlivých laboratórií",
        projects: "Špeciálne projekty",
        projectsDesc: "Zoznam projektov s možnosťou rozkliknúť detail",
        shop: "Všetky produkty",
        shopDesc: "Katalóg produktov - prototypy, doplnky, merch",
        researchTitle: "Výskum a vývoj",
        researchDesc: "Naše laboratóriá sa venujú výskumu najmodernejších technológií, od umelej inteligencie po pokročilú robotiku a bioinžinierstvo.",
        prototypesTitle: "Prototypy",
        prototypesDesc: "Vyvíjame a testujeme prototypy futuristických zariadení, ktoré posúvajú hranice toho, čo je technologicky možné.",
        experimentalTitle: "Experimentálne projekty",
        experimentalDesc: "Experimentujeme s technológiami, ktoré jsou na hrane súčasnej vedy a pripravujeme budúcnosť technologického pokroku."
      },
      shop: {
        title: "E-shop",
        addToCart: "Pridať do košíka",
        addedToCart: "Produkt bol pridaný do košíka",
        moreAboutProduct: "Viac o produkte",
        moreInfo: "Viac o produkte",
        cart: "Košík",
        checkout: "Objednať",
        price: "Cena",
        category: "Kategória",
        inquiry: "Dopyt",
        inquiryForm: "Formulár dopytu",
        emptyCart: "Košík je prázdny",
        orderForm: "Objednávkový formulár",
        sendOrder: "Odoslať objednávku",
        sending: "Odosielam...",
        loadingProducts: "Načítavam produkty...",
        popular: "POPULÁRNE",
        orderSent: "Objednávka odoslaná!",
        orderCreatedSuccessfully: "Vaša objednávka bola úspešne vytvorená",
        orderNumberLabel: "Číslo objednávky",
        paymentDetailsSent: "Platobné údaje boli odoslané na váš email.",
        paymentDeadline: "Prosím vykonajte platbu do",
        workingDays: "3 pracovných dní",
        accountNumber: "Číslo účtu:",
        variableSymbol: "Variabilný symbol:",
        continuesShopping: "Pokračovať v nákupe",
        selectQuantity: "Vyberte množstvo",
        cancel: "Zrušiť",
        add: "Pridať",
        soldOut: "Vypredané",
        description: "Popis",
        categories: "Kategórie",
        orderSummary: "Súhrn objednávky",
        shippingType: "Typ dopravy",
        subtotal: "Medzisúčet",
        shipping: "Doprava",
        total: "Celkom",
        order: "Objednať",
        fillDeliveryInfo: "Vyplňte dodacie údaje",
        nameCompany: "Meno / Firma",
        billingAddress: "Fakturačná adresa",
        shippingAddress: "Dodacia adresa (nechajte prázdne ak je rovnaká)",
        gateWidth: "Šírka brány (cm)",
        gateHeight: "Výška brány (cm)",
        workHours: "Pracovná doba pre závoz (napr. Po-Pia 7-15)",
        notes: "Poznámka / individuálne želanie",
        agreeTerms: "Súhlasím so spracovaním osobných údajov a",
        termsConditions: "obchodnými podmienkami",
        manual: "Manuál",
        downloadManual: "Stiahnuť manuál",
        videoTutorial: "Video návod",
        playVideo: "Prehrať video"
      },
      cart: {
        goodEvening: "Dobrý večer,",
        goodDay: "Dobrý deň,",
        privacyInfo: "Žiadne informácie o našich zákazníkoch neukladáme. Po vytvorení objednávky sa vytvorí objednávka a po expedícii sa celá karta zákazníka vymaže. Históriu nákupu možno dohľadať len cez faktúry uložené v zákonnej lehote.",
        thankYou: "Ďakujem",
        terms: "Obchodné podmienky"
      },
      contact: {
        title: "Kontakt",
        subtitle: "Uprednostňujeme emailovú komunikáciu, ktorá nám umožňuje presne reagovať a predchádzať nedorozumeniam. Ak potrebujete rýchle informácie, zavolajte nám alebo si dohodnite stretnutie.",
        serviceNote: "Servisné požiadavky posielajte vždy na email!",
        name: "Meno",
        email: "Email",
        phone: "Telefón",
        message: "Správa",
        send: "Odoslať",
        gdpr: "Súhlasím so spracovaním osobných údajov",
        required: "Povinné pole",
        contactInfo: "Kontaktné informácie",
        workingHours: "Pracovná doba",
        workingHoursText: "Po–Pia: 8:00 – 16:00 (technická podpora do 18:00)\nSo–Ne: Zatvorené (technická podpora do 14:00)",
        billingAddress: "Fakturačná adresa",
        billingAddressText: "CYBERTRONIC ROBOTICS S.R.O.\nAnenská 405/7\n69501 Hodonín\n(neprijímame tu poštu)",
        contactAddress: "Kontaktná adresa",
        contactAddressText: "CYBERTRONIC Unlimited\nIng. René Letocha\nSvatobořice 76\n69604 Svatobořice, okr. Hodonín",
        companyInfo: "Firemné údaje",
        companyInfoText: "IČO: 01526138 | DIČ: CZ01526138\nÚčet: 2700408786/2010 (Fio Banka)\nIBAN: CZ2220100000002700408786\nSWIFT/BIC: FIOBCZPPXXX\nRegistrácia: C 79792 vedená u Krajského súdu v Brne",
        map: "Mapa",
        contactUs: "Kontaktujte nás",
        phoneNote: "Ing. René Letocha – konateľ, vývoj",
        namePlaceholder: "Vaše meno",
        emailPlaceholder: "vas@email.sk",
        phonePlaceholder: "+421 777 875 098",
        messagePlaceholder: "Vaša správa...",
        sending: "Odosielanie...",
        successMessage: "Správa bola úspešne odoslaná! Čoskoro sa vám ozveme.",
        errorMessage: "Chyba pri odosielaní správy. Skúste to prosím znovu alebo nás kontaktujte priamo na email."
      },
      news: {
        subtitle: "Najnovšie správy zo sveta Cybertronic"
      },
      admin: {
        title: "Administrácia",
        login: "Prihlásenie",
        password: "Heslo",
        submit: "Odoslať",
        products: "Produkty",
        news: "Novinky",
        addProduct: "Pridať produkt",
        editProduct: "Upraviť produkt",
        adminPanel: "Admin panel",
        goToMainPage: "Prejdite na hlavnú stránku a prihláste sa ako admin pre správu produktov"
      },
      common: {
        noProductsInSection: "Žiadne produkty v tejto sekcii",
        productsWillBeAdded: "Produkty budú čoskoro pridané do jednotlivých sekcií",
        noProductsAvailable: "Zatiaľ nie sú k dispozícii žiadne produkty",
        completeOverview: "Kompletný prehľad všetkých našich produktov zo všetkých sekcií",
        addProduct: "Pridať produkt",
        addNewProduct: "Pridať nový produkt",
        manageCategories: "Spravovať kategórie",
        manageNews: "Spravovať novinky",
        editProduct: "Upraviť produkt",
        deleteProduct: "Zmazať produkt",
        saveChanges: "Uložiť zmeny",
        cancel: "Zrušiť",
        add: "Pridať",
        all: "Všetky",
        categoryManagement: "Správa kategórií",
        newsManagement: "Správa noviniek",
        addCategory: "Pridať kategóriu",
        addNews: "Pridať novinku",
        categoryName: "Názov kategórie",
        titleCs: "Názov (CS)",
        titleEn: "Názov (EN)",
        shortDescriptionCs: "Krátky popis (CS)",
        areYouSure: "Ste si istí, že chcete zmazať tento produkt?",
        yes: "ÁNO",
        no: "NIE",
        loadingProducts: "Načítavam produkty...",
        popular: "POPULÁRNE"
      },
      services: {
        title: "Služby",
        subtitle: "Profesionálne služby a riešenia na mieru. Okrem vývoja a výroby elektroniky ponúkame aj špecializované služby v oblasti obrábania materiálov a technickej podpory.",
        contactForServices: "Kontakt pre služby",
        polystyrene: {
          title: "Rezanie polystyrénu",
          description: "Ponúkame zákazkové rezanie polystyrénu podľa návrhu zákazníka. Prioritou je pre nás však vývoj a výroba elektroniky, preto môžeme zákazku z nedostatku času odmietnuť.",
          specs: "Vlastný počítačom riadená rezačka polystyrénu Alfa Cutter T2100 s pracovnou plochou 1300x1000x600mm.",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Špecifikácie:",
          materialsLabel: "Materiály:"
        },
        laser: {
          title: "Rezanie a gravírovanie laserom",
          description: "Ponúkame zákazkové rezanie a gravírovanie laserom podľa návrhu zákazníka.",
          specs: "CO2 laser s výkonom 60W s efektívnou pracovnou plochou 500x400mm",
          materials: "Sklo, plast, drevo, akrylátové sklo, plexisklo",
          priceLabel: "Cena:",
          specsLabel: "Špecifikácie:",
          materialsLabel: "Materiály:"
        },
        plasma: {
          title: "Rezanie kovov plazmou do 20mm",
          description: "Ponúkame zákazkové rezanie elektricky vodivých materiálov na CNC routeri s plazmou Pegas 101.",
          specs: "Efektívna pracovná plocha CNC plazmy je 1500x3000mm",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Špecifikácie:",
          materialsLabel: "Materiály:"
        },
        embroidery: {
          title: "Vyšívanie na textil automatom",
          description: "Ponúkame zákazkové vyšívanie návrhu vektorovej grafiky z Corelu na textilné materiály.",
          specs: "",
          materials: "Bundy, tričká, uteráky s kombináciou až 6 farieb v jednom motíve",
          priceLabel: "Cena:",
          specsLabel: "Špecifikácie:",
          materialsLabel: "Materiály:"
        },
        printing3d: {
          title: "3D tlač z ABS plastu",
          description: "Ponúkame zákazkový 3D tlač predmetov na 3D tlačiarňach s pracovnou plochou 200*200*200mm a 600*400*400mm.",
          specs: "",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Špecifikácie:",
          materialsLabel: "Materiály:"
        },
        welding: {
          title: "Zváračstvo hliníka, nehrdzavky a čierneho plechu - TIG, MIG",
          description: "Ponúkame zákazkové zváračstvo hliníka, nehrdzavky i čierneho plechu výkonnými automatickými zváračkami.",
          specs: "",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Špecifikácie:",
          materialsLabel: "Materiály:"
        },
        milling3d: {
          title: "3D frézovanie vrátane 3D skenovania",
          description: "Ponúkame zákazkové frézovanie 2D i 3D s možnosťou 3D skenovania predmetov s presnosťou 1mm.",
          specs: "Pracovná plocha 1500x2500x250mm, frézujeme mäkké materiály (plasty, drevo, hliník, mosadz, plexi)",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Špecifikácie:",
          materialsLabel: "Materiály:"
        },
        training: {
          title: "Školenie v oblasti elektroniky, CAD a CAM systémov",
          description: "Ponúkame odborné školenie na CAD a CAM systémy, elektronické systémy, rušenie, EMC.",
          specs: "",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Špecifikácie:",
          materialsLabel: "Materiály:"
        },
        service: {
          title: "Servisný výjazd",
          description: "Servis strojov je nutné hlásiť vopred najlepšie emailom s drobným popisom závady.",
          specs: "",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Špecifikácie:",
          materialsLabel: "Materiály:"
        },
        transport: {
          title: "Autodoprava",
          description: "Ponúkame drobnú autodopravu na valníku Peugeot Boxer 3,0 do 3,5 tony.",
          specs: "Veľkosť prepravnej plochy 2100x4100mm s maximálnou hmotnosťou 750Kg",
          materials: "",
          priceLabel: "Cena:",
          specsLabel: "Špecifikácie:",
          materialsLabel: "Materiály:"
        }
      },
      footer: {
        rights: "Všetky práva vyhradené",
        contact: "Kontakt",
        email: "Email",
        phone: "Telefón",
        description: "Budúcnosť technológie je tu. Špecializujeme sa na pokročilé robotické systémy a inovatívne riešenia.",
        websiteBy: "Tvorba webu:"
      },
      profile: {
        title: "Profil",
        founder: "Zakladateľ & CEO",
        bio: "Viac ako 15 rokov sa venuje tvorbe elektroniky, robotiky a automatizácie. Špecializuje sa na zákazkový vývoj a inovatívne technologické riešenia.",
        socialMedia: "Sociálne siete",
        contact: "Kontakt",
        admin: "Admin",
        adminLogin: "Prihlásenie administrátora",
        username: "Používateľské meno",
        login: "Prihlásiť",
        logout: "Odhlásiť",
        back: "Späť",
        changePhoto: "Zmeniť profilovú fotku",
        imageUrl: "URL obrázku",
        uploadFile: "Nahrať súbor",
        dragImage: "Pretiahnite obrázok sem",
        preview: "Náhľad",
        save: "Uložiť"
      },
      cookies: {
        title: "Cookies a súkromie",
        description: "Používame cookies na zlepšenie vášho zážitku, analýzu návštevnosti a marketingové účely. Vaše údaje sú spracovávané bezpečne a anonymne.",
        essential: "Nevyhnutné cookies",
        essentialDesc: "Vyžadované pre základnú funkčnosť webu. Vždy aktívne.",
        analytics: "Analytické cookies",
        analyticsDesc: "Pomáhajú nám pochopiť, ako návštevníci interagujú s našimi webovými stránkami (Google Analytics).",
        accept: "Prijať všetky cookies",
        decline: "Odmietnuť",
        showDetails: "Podrobnosti",
        hideDetails: "Skryť podrobnosti",
        footer: "Prijatím vyjadrujete súhlas s používaním cookies podľa našich Zásad ochrany osobných údajov."
      },
      tutorials: {
        title: "Video návody",
        subtitle: "Naučte sa používať naše produkty pomocou podrobných video návodov",
        noTutorials: "V tejto kategórii zatiaľ nie sú dostupné žiadne návody.",
        watchVideo: "Prehrať návod"
      }
    }
  },
  de: {
    translation: {
      navigation: {
        home: "Startseite",
        shop: "Alle Produkte",
        services: "Dienstleistungen",
        contact: "Kontakt",
        news: "Neuigkeiten",
        admin: "Admin",
        about: "Über uns",
        products: "Produkte",
        references: "Referenzen",
        laboratories: "Labore",
        projects: "Projekte"
      },
      landing: {
        title: "Cybertronic",
        subtitle: "Die Zukunft ist hier",
        description: "Pioniere in fortschrittlicher Technologie. Von intimen Geräten über Industrierobotik bis hin zu futuristischen Forschungsprojekten.",
        sexMachines: "Andere Maschinen",
        sexMachinesDesc: "Revolutionäre Technologie bei intimen Geräten mit KI-Steuerung",
        robotics: "Cybertronic Robotics",
        roboticsDesc: "Militärische und industrielle Robotersysteme nach Maß",
        unlimited: "Cybertronic Unlimited",
        unlimitedDesc: "Futuristische Labore und spezielle Forschungsprojekte",
        newBadge: "NEU",
        selectSection: "Wählen Sie einen Bereich zum Fortfahren"
      },
      sexMachines: {
        title: "Andere Maschinen",
        subtitle: "Revolutionäre Technologie für intime Geräte",
        description: "Unsere fortschrittlichsten Produkte kombinieren künstliche Intelligenz, Robotik und luxuriöses Design für unvergessliche Erlebnisse.",
        features: {
          ai: "KI-Steuerung",
          aiDesc: "Fortschrittliche Algorithmen für personalisierte Erfahrungen",
          safety: "Sicherheit",
          safetyDesc: "Höchste Qualitäts- und Sicherheitsstandards",
          premium: "Premium-Qualität",
          premiumDesc: "Luxusmaterialien und präzise Verarbeitung"
        },
        products: "Produkte",
        inquiry: "Unverbindliche Anfrage",
        inquiryDesc: "Interessiert an unseren Produkten? Kontaktieren Sie uns für weitere Informationen."
      },
      robotics: {
        title: "Cybertronic Robotics",
        subtitle: "Fortschrittliche Robotersysteme",
        description: "Wir spezialisieren uns auf die Entwicklung von Militär- und Industrierobotern, Automatisierung und kognitiver Intelligenz.",
        about: "Über uns",
        aboutDesc: "Geschichte und Fokus auf Robotersystementwicklung",
        products: "Produkte",
        productsDesc: "Militärroboter, Industrieroboter, Spezialsysteme",
        services: "Dienstleistungen",
        servicesDesc: "Kundenspezifische Entwicklung, Wartung, Service, Schulung",
        references: "Referenzen",
        referencesDesc: "Abgeschlossene Projekte mit Fotos und Beschreibungen"
      },
      unlimited: {
        title: "Cybertronic Unlimited",
        subtitle: "Futuristische Labore und Forschung",
        description: "Wir erforschen die fortschrittlichsten Technologien der Zukunft und verschieben die Grenzen von Wissenschaft und Technik.",
        about: "Über das Projekt",
        aboutDesc: "Beschreibung des Unlimited-Fokus und einzigartiger Technologien",
        laboratories: "Labore",
        laboratoriesDesc: "Fotogalerie und Beschreibung einzelner Labore",
        projects: "Spezielle Projekte",
        projectsDesc: "Liste der Projekte mit erweiterbaren Details",
        shop: "Alle Produkte",
        shopDesc: "Produktkatalog - Prototypen, Zubehör, Merch",
        researchTitle: "Forschung und Entwicklung",
        researchDesc: "Unsere Labore widmen sich der Erforschung modernster Technologien, von künstlicher Intelligenz bis hin zu fortgeschrittener Robotik und Bioengineering.",
        prototypesTitle: "Prototypen",
        prototypesDesc: "Wir entwickeln und testen Prototypen futuristischer Geräte, die die Grenzen des technologisch Möglichen verschieben.",
        experimentalTitle: "Experimentelle Projekte",
        experimentalDesc: "Wir experimentieren mit Technologien, die an der Grenze der heutigen Wissenschaft liegen und bereiten die Zukunft des technologischen Fortschritts vor."
      },
      shop: {
        title: "E-shop",
        addToCart: "In den Warenkorb",
        addedToCart: "Produkt wurde in den Warenkorb gelegt",
        moreAboutProduct: "Mehr über das Produkt",
        moreInfo: "Mehr über das Produkt",
        cart: "Warenkorb",
        checkout: "Bestellen",
        price: "Preis",
        category: "Kategorie",
        inquiry: "Anfrage",
        inquiryForm: "Anfrageformular",
        emptyCart: "Warenkorb ist leer",
        orderForm: "Bestellformular",
        sendOrder: "Bestellung senden",
        sending: "Senden...",
        loadingProducts: "Produkte werden geladen...",
        popular: "BELIEBT",
        orderSent: "Bestellung gesendet!",
        orderCreatedSuccessfully: "Ihre Bestellung wurde erfolgreich erstellt",
        orderNumberLabel: "Bestellnummer",
        paymentDetailsSent: "Zahlungsdetails wurden an Ihre E-Mail gesendet.",
        paymentDeadline: "Bitte zahlen Sie innerhalb von",
        workingDays: "3 Werktagen",
        accountNumber: "Kontonummer:",
        variableSymbol: "Variables Symbol:",
        continuesShopping: "Weiter einkaufen",
        selectQuantity: "Menge auswählen",
        cancel: "Abbrechen",
        add: "Hinzufügen",
        soldOut: "Ausverkauft",
        description: "Beschreibung",
        categories: "Kategorien",
        orderSummary: "Bestellübersicht",
        shippingType: "Versandart",
        subtotal: "Zwischensumme",
        shipping: "Versand",
        total: "Gesamt",
        order: "Bestellen",
        fillDeliveryInfo: "Lieferinformationen ausfüllen",
        nameCompany: "Name / Firma",
        billingAddress: "Rechnungsadresse",
        shippingAddress: "Lieferadresse (leer lassen wenn gleich)",
        gateWidth: "Torbreite (cm)",
        gateHeight: "Torhöhe (cm)",
        workHours: "Arbeitszeiten für Lieferung (z.B. Mo-Fr 7-15)",
        notes: "Notiz / individuelle Wünsche",
        agreeTerms: "Ich stimme der Verarbeitung personenbezogener Daten und den",
        termsConditions: "Geschäftsbedingungen zu",
        manual: "Handbuch",
        downloadManual: "Handbuch herunterladen",
        videoTutorial: "Video-Anleitung",
        playVideo: "Video abspielen"
      },
      cart: {
        goodEvening: "Guten Abend,",
        goodDay: "Guten Tag,",
        privacyInfo: "Wir speichern keine Informationen über unsere Kunden. Nach der Erstellung einer Bestellung wird die Bestellung erstellt und nach dem Versand wird die gesamte Kundenkarte gelöscht. Die Kaufhistorie kann nur über Rechnungen nachverfolgt werden, die gemäß der gesetzlichen Frist gespeichert sind.",
        thankYou: "Danke",
        terms: "Geschäftsbedingungen"
      },
      contact: {
        title: "Kontakt",
        subtitle: "Wir bevorzugen E-Mail-Kommunikation, die es uns ermöglicht, präzise zu reagieren und Missverständnisse zu vermeiden. Wenn Sie schnelle Informationen benötigen, rufen Sie uns an oder vereinbaren Sie einen Termin.",
        serviceNote: "Service-Anfragen senden Sie bitte immer per E-Mail!",
        name: "Name",
        email: "E-Mail",
        phone: "Telefon",
        message: "Nachricht",
        send: "Senden",
        gdpr: "Ich stimme der Verarbeitung personenbezogener Daten zu",
        required: "Pflichtfeld",
        contactInfo: "Kontaktinformationen",
        workingHours: "Arbeitszeiten",
        workingHoursText: "Mo–Fr: 8:00 – 16:00 (technischer Support bis 18:00)\nSa–So: Geschlossen (technischer Support bis 14:00)",
        billingAddress: "Rechnungsadresse",
        billingAddressText: "CYBERTRONIC ROBOTICS S.R.O.\nAnenská 405/7\n69501 Hodonín\n(wir nehmen hier keine Post an)",
        contactAddress: "Kontaktadresse",
        contactAddressText: "CYBERTRONIC Unlimited\nIng. René Letocha\nSvatobořice 76\n69604 Svatobořice, okr. Hodonín",
        companyInfo: "Firmeninformationen",
        companyInfoText: "IČO: 01526138 | DIČ: CZ01526138\nKonto: 2700408786/2010 (Fio Banka)\nIBAN: CZ2220100000002700408786\nSWIFT/BIC: FIOBCZPPXXX\nRegistrierung: C 79792 geführt beim Kreisgericht in Brno",
        map: "Karte",
        contactUs: "Kontaktieren Sie uns",
        phoneNote: "Ing. René Letocha – Geschäftsführer, Entwicklung",
        namePlaceholder: "Ihr Name",
        emailPlaceholder: "ihre@email.de",
        phonePlaceholder: "+49 123 456 789",
        messagePlaceholder: "Ihre Nachricht...",
        sending: "Senden...",
        successMessage: "Nachricht erfolgreich gesendet! Wir werden uns bald bei Ihnen melden.",
        errorMessage: "Fehler beim Senden der Nachricht. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt per E-Mail."
      },
      news: {
        subtitle: "Neueste Nachrichten aus der Welt von Cybertronic"
      },
      admin: {
        title: "Administration",
        login: "Anmeldung",
        password: "Passwort",
        submit: "Senden",
        products: "Produkte",
        news: "Neuigkeiten",
        addProduct: "Produkt hinzufügen",
        editProduct: "Produkt bearbeiten",
        adminPanel: "Admin-Panel",
        goToMainPage: "Gehen Sie zur Hauptseite und melden Sie sich als Admin an, um Produkte zu verwalten"
      },
      common: {
        noProductsInSection: "Keine Produkte in diesem Bereich",
        productsWillBeAdded: "Produkte werden bald zu den einzelnen Bereichen hinzugefügt",
        noProductsAvailable: "Noch keine Produkte verfügbar",
        completeOverview: "Vollständige Übersicht aller unserer Produkte aus allen Bereichen",
        addProduct: "Produkt hinzufügen",
        addNewProduct: "Neues Produkt hinzufügen",
        manageCategories: "Kategorien verwalten",
        manageNews: "Nachrichten verwalten",
        editProduct: "Produkt bearbeiten",
        deleteProduct: "Produkt löschen",
        saveChanges: "Änderungen speichern",
        cancel: "Abbrechen",
        add: "Hinzufügen",
        all: "Alle",
        categoryManagement: "Kategorienverwaltung",
        newsManagement: "Nachrichtenverwaltung",
        addCategory: "Kategorie hinzufügen",
        addNews: "Nachricht hinzufügen",
        categoryName: "Kategoriename",
        titleCs: "Titel (CS)",
        titleEn: "Titel (EN)",
        shortDescriptionCs: "Kurze Beschreibung (CS)",
        areYouSure: "Sind Sie sicher, dass Sie dieses Produkt löschen möchten?",
        yes: "JA",
        no: "NEIN",
        loadingProducts: "Produkte werden geladen...",
        popular: "BELIEBT"
      },
      services: {
        title: "Dienstleistungen",
        subtitle: "Professionelle Dienstleistungen und maßgeschneiderte Lösungen. Neben der Entwicklung und Herstellung von Elektronik bieten wir auch spezialisierte Dienstleistungen in der Materialbearbeitung und technischen Unterstützung.",
        contactForServices: "Kontakt für Dienstleistungen",
        polystyrene: {
          title: "Polystyrol-Schneiden",
          description: "Wir bieten kundenspezifisches Polystyrol-Schneiden nach Kundendesign. Priorität hat jedoch die Entwicklung und Herstellung von Elektronik, daher können wir Aufträge aus Zeitmangel ablehnen.",
          specs: "Eigener computergesteuerter Polystyrol-Schneider Alfa Cutter T2100 mit Arbeitsfläche 1300x1000x600mm.",
          materials: "",
          priceLabel: "Preis:",
          specsLabel: "Spezifikationen:",
          materialsLabel: "Materialien:"
        },
        laser: {
          title: "Laser-Schneiden und Gravieren",
          description: "Wir bieten kundenspezifisches Laser-Schneiden und Gravieren nach Kundendesign.",
          specs: "CO2-Laser mit 60W Leistung und effektiver Arbeitsfläche 500x400mm",
          materials: "Glas, Kunststoff, Holz, Acrylglas, Plexiglas",
          priceLabel: "Preis:",
          specsLabel: "Spezifikationen:",
          materialsLabel: "Materialien:"
        },
        plasma: {
          title: "Metall-Plasma-Schneiden bis 20mm",
          description: "Wir bieten kundenspezifisches Schneiden elektrisch leitfähiger Materialien auf CNC-Router mit Plasma Pegas 101.",
          specs: "Effektive Arbeitsfläche der CNC-Plasma ist 1500x3000mm",
          materials: "",
          priceLabel: "Preis:",
          specsLabel: "Spezifikationen:",
          materialsLabel: "Materialien:"
        },
        embroidery: {
          title: "Automatisches Sticken auf Textilien",
          description: "Wir bieten kundenspezifisches Sticken von Vektorgrafik-Designs aus Corel auf Textilmaterialien.",
          specs: "",
          materials: "Jacken, T-Shirts, Handtücher mit Kombination von bis zu 6 Farben in einem Motiv",
          priceLabel: "Preis:",
          specsLabel: "Spezifikationen:",
          materialsLabel: "Materialien:"
        },
        printing3d: {
          title: "3D-Druck aus ABS-Kunststoff",
          description: "Wir bieten kundenspezifischen 3D-Druck von Objekten auf 3D-Druckern mit Arbeitsfläche 200*200*200mm und 600*400*400mm.",
          specs: "",
          materials: "",
          priceLabel: "Preis:",
          specsLabel: "Spezifikationen:",
          materialsLabel: "Materialien:"
        },
        welding: {
          title: "Schweißen von Aluminium, Edelstahl und Schwarzblech - TIG, MIG",
          description: "Wir bieten kundenspezifisches Schweißen von Aluminium, Edelstahl und Schwarzblech mit leistungsstarken automatischen Schweißgeräten.",
          specs: "",
          materials: "",
          priceLabel: "Preis:",
          specsLabel: "Spezifikationen:",
          materialsLabel: "Materialien:"
        },
        milling3d: {
          title: "3D-Fräsen einschließlich 3D-Scannen",
          description: "Wir bieten kundenspezifisches 2D- und 3D-Fräsen mit der Möglichkeit des 3D-Scannens von Objekten mit 1mm Genauigkeit.",
          specs: "Arbeitsfläche 1500x2500x250mm, wir fräsen weiche Materialien (Kunststoffe, Holz, Aluminium, Messing, Plexi)",
          materials: "",
          priceLabel: "Preis:",
          specsLabel: "Spezifikationen:",
          materialsLabel: "Materialien:"
        },
        training: {
          title: "Schulung in Elektronik, CAD- und CAM-Systemen",
          description: "Wir bieten Fachschulungen zu CAD- und CAM-Systemen, elektronischen Systemen, Störungen, EMV.",
          specs: "",
          materials: "",
          priceLabel: "Preis:",
          specsLabel: "Spezifikationen:",
          materialsLabel: "Materialien:"
        },
        service: {
          title: "Service-Einsatz",
          description: "Service für Maschinen muss im Voraus gemeldet werden, am besten per E-Mail mit kurzer Fehlerbeschreibung.",
          specs: "",
          materials: "",
          priceLabel: "Preis:",
          specsLabel: "Spezifikationen:",
          materialsLabel: "Materialien:"
        },
        transport: {
          title: "Autotransport",
          description: "Wir bieten kleinen Autotransport auf Pritschenwagen Peugeot Boxer 3,0 bis 3,5 Tonnen.",
          specs: "Transportflächengröße 2100x4100mm mit maximalem Gewicht 750Kg",
          materials: "",
          priceLabel: "Preis:",
          specsLabel: "Spezifikationen:",
          materialsLabel: "Materialien:"
        }
      },
      footer: {
        rights: "Alle Rechte vorbehalten",
        contact: "Kontakt",
        email: "E-Mail",
        phone: "Telefon",
        description: "Die Zukunft der Technologie ist hier. Wir spezialisieren uns auf fortschrittliche Robotersysteme und innovative Lösungen.",
        websiteBy: "Website erstellt von:"
      },
      profile: {
        title: "Profil",
        founder: "Gründer & CEO",
        bio: "Seit mehr als 15 Jahren beschäftigt er sich mit der Entwicklung von Elektronik, Robotik und Automatisierung. Er spezialisiert sich auf kundenspezifische Entwicklung und innovative technologische Lösungen.",
        socialMedia: "Soziale Medien",
        contact: "Kontakt",
        admin: "Admin",
        adminLogin: "Administrator-Anmeldung",
        username: "Benutzername",
        login: "Anmelden",
        logout: "Abmelden",
        back: "Zurück",
        changePhoto: "Profilbild ändern",
        imageUrl: "Bild-URL",
        uploadFile: "Datei hochladen",
        dragImage: "Bild hierher ziehen",
        preview: "Vorschau",
        save: "Speichern"
      },
      cookies: {
        title: "Cookies & Datenschutz",
        description: "Wir verwenden Cookies, um Ihr Erlebnis zu verbessern, den Website-Verkehr zu analysieren und für Marketingzwecke. Ihre Daten werden sicher und anonym verarbeitet.",
        essential: "Notwendige Cookies",
        essentialDesc: "Erforderlich für die grundlegende Funktionalität der Website. Immer aktiv.",
        analytics: "Analytische Cookies",
        analyticsDesc: "Helfen uns zu verstehen, wie Besucher mit unserer Website interagieren (Google Analytics).",
        accept: "Alle Cookies akzeptieren",
        decline: "Ablehnen",
        showDetails: "Details",
        hideDetails: "Details ausblenden",
        footer: "Durch Akzeptieren stimmen Sie unserer Verwendung von Cookies gemäß unserer Datenschutzrichtlinie zu."
      },
      tutorials: {
        title: "Video-Anleitungen",
        subtitle: "Lernen Sie, wie Sie unsere Produkte mit Schritt-für-Schritt-Videoanleitungen verwenden",
        noTutorials: "In dieser Kategorie sind noch keine Tutorials verfügbar.",
        watchVideo: "Tutorial ansehen"
      }
    }
  },
  en: {
    translation: {
      navigation: {
        home: "Home",
        shop: "All products",
        services: "Services",
        contact: "Contact",
        news: "News",
        admin: "Admin",
        about: "About",
        products: "Products",
        references: "References",
        laboratories: "Laboratories",
        projects: "Projects"
      },
      landing: {
        title: "Cybertronic",
        subtitle: "The future is here",
        description: "Pioneers in advanced technology. From intimate devices through industrial robotics to futuristic research projects.",
        sexMachines: "Other machines",
        sexMachinesDesc: "Revolutionary technology in intimate devices with AI control",
        robotics: "Cybertronic Robotics",
        roboticsDesc: "Military and industrial robotic systems made to order",
        unlimited: "Cybertronic Unlimited",
        unlimitedDesc: "Futuristic laboratories and special research projects",
        newBadge: "NEW",
        selectSection: "Choose a section to continue"
      },
      sexMachines: {
        title: "Other machines",
        subtitle: "Revolutionary intimate device technology",
        description: "Our most advanced products combine artificial intelligence, robotics and luxury design for unforgettable experiences.",
        features: {
          ai: "AI Control",
          aiDesc: "Advanced algorithms for personalized experience",
          safety: "Safety",
          safetyDesc: "Highest quality and safety standards",
          premium: "Premium Quality",
          premiumDesc: "Luxury materials and precise craftsmanship"
        },
        products: "Products",
        inquiry: "Non-binding Inquiry",
        inquiryDesc: "Interested in our products? Contact us for more information."
      },
      robotics: {
        title: "Cybertronic Robotics",
        subtitle: "Advanced robotic systems",
        description: "We specialize in developing military and industrial robots, automation and cognitive intelligence.",
        about: "About Us",
        aboutDesc: "History and focus on robotic systems development",
        products: "Products",
        productsDesc: "Military robots, industrial robots, special systems",
        services: "Services",
        servicesDesc: "Custom development, maintenance, service, training",
        references: "References",
        referencesDesc: "Completed projects with photos and descriptions"
      },
      unlimited: {
        title: "Cybertronic Unlimited",
        subtitle: "Futuristic laboratories and research",
        description: "We explore the most advanced technologies of the future and push the boundaries of science and technology.",
        about: "About Project",
        aboutDesc: "Description of Unlimited focus and unique technologies",
        laboratories: "Laboratories",
        laboratoriesDesc: "Photo gallery and description of individual laboratories",
        projects: "Special Projects",
        projectsDesc: "List of projects with expandable details",
        shop: "All products",
        shopDesc: "Product catalog - prototypes, accessories, merch",
        researchTitle: "Research and Development",
        researchDesc: "Our laboratories are dedicated to researching the most advanced technologies, from artificial intelligence to advanced robotics and bioengineering.",
        prototypesTitle: "Prototypes",
        prototypesDesc: "We develop and test prototypes of futuristic devices that push the boundaries of what is technologically possible.",
        experimentalTitle: "Experimental Projects",
        experimentalDesc: "We experiment with technologies that are at the edge of current science and prepare the future of technological progress."
      },
      shop: {
        title: "E-shop",
        addToCart: "Add to Cart",
        addedToCart: "Product added to cart",
        moreAboutProduct: "More about product",
        cart: "Cart",
        checkout: "Checkout",
        price: "Price",
        category: "Category",
        inquiry: "Inquiry",
        inquiryForm: "Inquiry Form",
        selectQuantity: "Select quantity",
        cancel: "Cancel",
        add: "Add",
        soldOut: "Sold out",
        description: "Description",
        categories: "Categories",
        orderSummary: "Order summary",
        shippingType: "Shipping type",
        subtotal: "Subtotal",
        shipping: "Shipping",
        total: "Total",
        order: "Order",
        fillDeliveryInfo: "Fill delivery information",
        nameCompany: "Name / Company",
        billingAddress: "Billing address",
        shippingAddress: "Shipping address (leave empty if same)",
        gateWidth: "Gate width (cm)",
        gateHeight: "Gate height (cm)",
        workHours: "Working hours for delivery (e.g. Mon-Fri 7-15)",
        notes: "Note / individual wishes",
        agreeTerms: "I agree to personal data processing and",
        termsConditions: "terms and conditions",
        sendOrder: "Send order",
        sending: "Sending...",
        emptyCart: "Cart is empty",
        orderForm: "Order form",
        loadingProducts: "Loading products...",
        popular: "POPULAR",
        orderSent: "Order sent!",
        orderCreatedSuccessfully: "Your order has been successfully created",
        orderNumberLabel: "Order number",
        paymentDetailsSent: "Payment details have been sent to your email.",
        paymentDeadline: "Please make payment within",
        workingDays: "3 working days",
        accountNumber: "Account number:",
        variableSymbol: "Variable symbol:",
        continuesShopping: "Continue shopping",
        manual: "Manual",
        downloadManual: "Download manual",
        videoTutorial: "Video tutorial",
        playVideo: "Play video"
      },
      cart: {
        goodEvening: "Good evening,",
        goodDay: "Good day,",
        privacyInfo: "We do not store any information about our customers. After creating an order, the order is created and after shipping, the entire customer card is deleted. Purchase history can only be traced through invoices stored according to the legal deadline.",
        thankYou: "Thank you",
        terms: "Terms and Conditions"
      },
      contact: {
        title: "Contact",
        subtitle: "We prefer email communication, which allows us to respond precisely and prevent misunderstandings. If you need quick information, call us or arrange a meeting.",
        serviceNote: "Always send service requests by email!",
        name: "Name",
        email: "Email",
        phone: "Phone",
        message: "Message",
        send: "Send",
        gdpr: "I agree to personal data processing",
        required: "Required field",
        contactInfo: "Contact information",
        workingHours: "Working hours",
        workingHoursText: "Mon–Fri: 8:00 – 16:00 (technical support until 18:00)\nSat–Sun: Closed (technical support until 14:00)",
        billingAddress: "Billing address",
        billingAddressText: "CYBERTRONIC ROBOTICS S.R.O.\nAnenská 405/7\n69501 Hodonín\n(we do not accept mail here)",
        contactAddress: "Contact address",
        contactAddressText: "CYBERTRONIC Unlimited\nIng. René Letocha\nSvatobořice 76\n69604 Svatobořice, okr. Hodonín",
        companyInfo: "Company information",
        companyInfoText: "IČO: 01526138 | DIČ: CZ01526138\nAccount: 2700408786/2010 (Fio Banka)\nIBAN: CZ2220100000002700408786\nSWIFT/BIC: FIOBCZPPXXX\nRegistration: C 79792 maintained at Regional Court in Brno",
        map: "Map",
        contactUs: "Contact us",
        phoneNote: "Ing. René Letocha – CEO, development",
        namePlaceholder: "Your name",
        emailPlaceholder: "your@email.com",
        phonePlaceholder: "+1 234 567 890",
        messagePlaceholder: "Your message...",
        sending: "Sending...",
        successMessage: "Message sent successfully! We will contact you soon.",
        errorMessage: "Error sending message. Please try again or contact us directly by email."
      },
      news: {
        subtitle: "Latest news from the world of Cybertronic"
      },
      admin: {
        title: "Administration",
        login: "Login",
        password: "Password",
        submit: "Submit",
        products: "Products",
        news: "News",
        addProduct: "Add Product",
        editProduct: "Edit Product",
        adminPanel: "Admin panel",
        goToMainPage: "Go to main page and log in as admin to manage products"
      },
      common: {
        noProductsInSection: "No products in this section",
        productsWillBeAdded: "Products will be added to individual sections soon",
        noProductsAvailable: "No products available yet",
        completeOverview: "Complete overview of all our products from all sections",
        addProduct: "Add product",
        addNewProduct: "Add new product",
        manageCategories: "Manage categories",
        manageNews: "Manage news",
        editProduct: "Edit product",
        deleteProduct: "Delete product",
        saveChanges: "Save changes",
        cancel: "Cancel",
        add: "Add",
        all: "All",
        categoryManagement: "Category management",
        newsManagement: "News management",
        addCategory: "Add category",
        addNews: "Add news",
        categoryName: "Category name",
        titleCs: "Title (CS)",
        titleEn: "Title (EN)",
        shortDescriptionCs: "Short description (CS)",
        areYouSure: "Are you sure you want to delete this product?",
        yes: "YES",
        no: "NO",
        loadingProducts: "Loading products...",
        popular: "POPULAR"
      },
      services: {
        title: "Services",
        subtitle: "Professional services and custom solutions. In addition to electronics development and manufacturing, we also offer specialized services in material processing and technical support.",
        contactForServices: "Contact for services",
        polystyrene: {
          title: "Polystyrene cutting",
          description: "We offer custom polystyrene cutting according to customer design. However, our priority is electronics development and manufacturing, so we may decline orders due to lack of time.",
          specs: "Own computer-controlled polystyrene cutter Alfa Cutter T2100 with working area 1300x1000x600mm.",
          materials: "",
          priceLabel: "Price:",
          specsLabel: "Specifications:",
          materialsLabel: "Materials:"
        },
        laser: {
          title: "Laser cutting and engraving",
          description: "We offer custom laser cutting and engraving according to customer design.",
          specs: "CO2 laser with 60W power and effective working area 500x400mm",
          materials: "Glass, plastic, wood, acrylic glass, plexiglass",
          priceLabel: "Price:",
          specsLabel: "Specifications:",
          materialsLabel: "Materials:"
        },
        plasma: {
          title: "Metal plasma cutting up to 20mm",
          description: "We offer custom cutting of electrically conductive materials on CNC router with Plasma Pegas 101.",
          specs: "Effective working area of CNC plasma is 1500x3000mm",
          materials: "",
          priceLabel: "Price:",
          specsLabel: "Specifications:",
          materialsLabel: "Materials:"
        },
        embroidery: {
          title: "Automatic textile embroidery",
          description: "We offer custom embroidery of vector graphics designs from Corel on textile materials.",
          specs: "",
          materials: "Jackets, t-shirts, towels with combination of up to 6 colors in one motif",
          priceLabel: "Price:",
          specsLabel: "Specifications:",
          materialsLabel: "Materials:"
        },
        printing3d: {
          title: "3D printing from ABS plastic",
          description: "We offer custom 3D printing of objects on 3D printers with working area 200*200*200mm and 600*400*400mm.",
          specs: "",
          materials: "",
          priceLabel: "Price:",
          specsLabel: "Specifications:",
          materialsLabel: "Materials:"
        },
        welding: {
          title: "Welding aluminum, stainless steel and black sheet - TIG, MIG",
          description: "We offer custom welding of aluminum, stainless steel and black sheet with powerful automatic welders.",
          specs: "",
          materials: "",
          priceLabel: "Price:",
          specsLabel: "Specifications:",
          materialsLabel: "Materials:"
        },
        milling3d: {
          title: "3D milling including 3D scanning",
          description: "We offer custom 2D and 3D milling with possibility of 3D scanning of objects with 1mm accuracy.",
          specs: "Working area 1500x2500x250mm, we mill soft materials (plastics, wood, aluminum, brass, plexi)",
          materials: "",
          priceLabel: "Price:",
          specsLabel: "Specifications:",
          materialsLabel: "Materials:"
        },
        training: {
          title: "Training in electronics, CAD and CAM systems",
          description: "We offer professional training on CAD and CAM systems, electronic systems, interference, EMC.",
          specs: "",
          materials: "",
          priceLabel: "Price:",
          specsLabel: "Specifications:",
          materialsLabel: "Materials:"
        },
        service: {
          title: "Service call",
          description: "Machine service must be reported in advance, preferably by email with a brief description of the fault.",
          specs: "",
          materials: "",
          priceLabel: "Price:",
          specsLabel: "Specifications:",
          materialsLabel: "Materials:"
        },
        transport: {
          title: "Auto transport",
          description: "We offer small auto transport on flatbed Peugeot Boxer 3.0 up to 3.5 tons.",
          specs: "Transport area size 2100x4100mm with maximum weight 750Kg",
          materials: "",
          priceLabel: "Price:",
          specsLabel: "Specifications:",
          materialsLabel: "Materials:"
        }
      },
      footer: {
        rights: "All rights reserved",
        contact: "Contact",
        email: "Email",
        phone: "Phone",
        description: "The future of technology is here. We specialize in advanced robotic systems and innovative solutions.",
        websiteBy: "Website by:"
      },
      profile: {
        title: "Profile",
        founder: "Founder & CEO",
        bio: "For more than 15 years, he has been dedicated to creating electronics, robotics and automation. He specializes in custom development and innovative technological solutions.",
        socialMedia: "Social Media",
        contact: "Contact",
        admin: "Admin",
        adminLogin: "Administrator Login",
        username: "Username",
        login: "Login",
        logout: "Logout",
        back: "Back",
        changePhoto: "Change Profile Photo",
        imageUrl: "Image URL",
        uploadFile: "Upload File",
        dragImage: "Drag image here",
        preview: "Preview",
        save: "Save"
      },
      cookies: {
        title: "Cookies & Privacy",
        description: "We use cookies to enhance your experience, analyze site traffic, and for marketing purposes. Your data is processed securely and anonymously.",
        essential: "Essential Cookies",
        essentialDesc: "Required for basic site functionality. Always active.",
        analytics: "Analytics Cookies",
        analyticsDesc: "Help us understand how visitors interact with our website (Google Analytics).",
        accept: "Accept All Cookies",
        decline: "Decline",
        showDetails: "Details",
        hideDetails: "Hide Details",
        footer: "By accepting, you consent to our use of cookies as described in our Privacy Policy."
      },
      tutorials: {
        title: "Video Tutorials",
        subtitle: "Learn how to use our products with step-by-step video guides",
        noTutorials: "No tutorials available in this category yet.",
        watchVideo: "Watch Tutorial"
      }
    },
    "about": {
      "title": "O nás",
      "unlimited": {
        "aboutUs": "O nás",
        "description": "Sme vývojová spoločnosť CYBERTRONIC Unlimited s dlhoročnou tradíciou v ČR. Zameriavame sa na zákazkový vývoj a výrobu elektronických komponentov a stavebníc. Našou hlavnou činnosťou je vývoj a výskum v oblasti elektrotechniky, robotiky a bioniky.",
        "customDescription": "Okrem toho ponúkame výrobu elektroniky na mieru – presne podľa vašich predstáv – a dodávku systémov formou stavebnice. Vaše želanie je naša výzva!",
        "history": "História",
        "year2001": "spoločnosť založil René Letocha (vtedy študent SPŠE Brno) pod názvom Elektronik. Zameriavala sa na bezpečnostnú techniku, kamerové systémy a výrobu elektroniky pre menšie firmy.",
        "year2005": "premenovanie na Cybertronic, rozšírenie činnosti a prvé veľké projekty. Skúsenosti podporené štúdiom na VUT Brno.",
        "year2010": "vznik oficiálneho názvu LETOCHA René, CYBERTRONIC Unlimited. Firma sa rozdelila do niekoľkých divízií a rozšírila ponuku v oblasti robotiky, bioniky a zákazkovej elektroniky.",
        "divisions": "Divízie spoločnosti CYBERTRONIC Unlimited",
        "cai": {
          "title": "CAI – Cybertronic Automotive Industry",
          "description": "Zákazkový návrh elektronických komponentov pre automobilový priemysel."
        },
        "cei": {
          "title": "CEI – Cybertronic Engineering Industry",
          "description": "Vývoj elektroniky pre strojárstvo, CNC stroje a drobnú strojársku výrobu pre robotiku (väčšie projekty realizuje CYBERTRONIC Robotics s.r.o.)."
        },
        "cbi": {
          "title": "CBI – Cybertronic Building Industry",
          "description": "Automatizácia domácností, vlastné bezpečnostné systémy, výskum alternatívnych zdrojov energie a reverzné inžinierstvo."
        },
        "cdi": {
          "title": "CDI – Cybertronic Different Industry",
          "description": "Elektronika na mieru pre projekty, ktoré nespadajú do ostatných divízií."
        }
      },
      "robotics": {
        "aboutUs": "O nás – CYBERTRONIC Robotics s.r.o.",
        "description": "Sme vývojová spoločnosť zameraná na zákazkový vývoj automatizácie, robotiky a kognitívnej inteligencie. Kombinujeme hlboké znalosti strojárstva a elektronických systémov, aby sme pretavili myšlienky zákazníkov do funkčných, spoľahlivých a inovatívnych riešení.",
        "priority": "Naša priorita nie je len predať, ale vytvoriť produkt, ktorý bude zákazníkovi prinášať radosť a úžitok. Postavíme vám na mieru akýkoľvek stroj, výrobný či výdajný automat. Vaše želanie je naša výzva.",
        "specialization": "Naša špecializácia",
        "cncPortals": "Výroba zákazkových páliacich CNC portálov",
        "cncRouters": "Výroba frézovacích CNC routerov",
        "customMachines": "Individuálna konštrukcia strojov a automatov na mieru",
        "results": "Naše výsledky",
        "soldCnc": "V ČR a SK sme predali viac ako 500 CNC plotrov",
        "plasmaPlotters": "Viac ako 400 z nich sú plazmové plotre prvej a druhej generácie",
        "experience": "Máme mnohoročné skúsenosti podložené bohatou videodokumentáciou na YouTube kanáli",
        "support": "K našim strojom poskytujeme videonávody, inštalačné balíčky a neustále aktualizácie vylepšení",
        "responsibility": "Zodpovedný prístup",
        "wasteManagement": "Sme zapojení do kolektívneho odpadového hospodárstva REMA System a.s., pretože veríme, že inovácie a udržateľnosť idú ruka v ruke."
      }
    }
  }
};

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'cz',
    fallbackLng: 'cz',
    debug: false,
    backend: {
      loadPath: '/locales/{{lng}}/common.json',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;